export default "__VITE_ASSET__BvOXXK7t__"